import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ContractorTeam.css';
import {
  goToEditContractor,
  loadUserFormRequest,
  loadTechnicianFormRequest,
  loadUsersRequest,
  loadTechnicianRequest,
  setCurrentUserId,
  setCurrentTechnicianId,
  setShowInviteUserModal,
  setShowInviteTechnicianModal,
  ContactorTeamTabs,
} from 'actions/admin/team/contractor-team';
import {
  loadContractorRequest,
  showSignMsaModal,
  hideMsaSigningModal,
} from 'actions/admin/contractors/contractors';
import { UserModalState } from 'components/shared/modal/InviteUserModal';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import DetailsHeader from 'components/shared/details/DetailsHeader';
import ContractorStatus from 'components/admin/contractors/ContractorStatus';
import DetailsInfo from 'components/shared/details/DetailsInfo';
import DetailsInfoItem from 'components/shared/details/DetailsInfoItem';
import {
  getCurrentContractor,
  getMsaSigningUrl,
  getShowMsaSigningModal,
} from 'selectors/admin/contractors/contractors';
import { getCurrentUser } from 'selectors/authentication';
import { getUsers, getActiveTab } from 'selectors/admin/team/contractor-team';
import ContractorTeamUserModalContainer from 'components/admin/team/ContractorTeamUserModalContainer';
import ContractorTeamTechnicianModalContainer from 'components/admin/team/ContractorTeamTechnicianModalContainer';
import { formatPhoneNumber } from 'services/utils/text-util';
import ContractorDocumentsViewer from 'components/admin/contractors/ContractorDocumentsViewer';
import SigningModal from 'components/shared/modal/SigningModal';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import UsersTable from 'components/admin/team/UsersTable';
import TechniciansTable from 'components/admin/team/TechniciansTable';

class ContractorTeam extends Component {
  constructor(props) {
    super(props);
    this.contractorId = this.props.currentUser.accountable_id;
  }

  componentDidMount() {
    this.props
      .dispatch(loadContractorRequest(this.contractorId))
      .then((response) => {
        if (response.ok) {
          this.props.dispatch(loadUsersRequest());
        }
      });
  }

  handleEdit = () => {
    this.props.dispatch(goToEditContractor());
  };

  handleInviteUser = (event) => {
    event.preventDefault();
    this.props.dispatch(setCurrentUserId(0));
    this.props.dispatch(loadUserFormRequest(null));
    this.props.dispatch(setShowInviteUserModal(true, UserModalState.NEW));
  };

  handleInviteTechnician = (event) => {
    event.preventDefault();
    this.props.dispatch(setCurrentTechnicianId(0));
    this.props.dispatch(loadTechnicianFormRequest(null));
    this.props.dispatch(setShowInviteTechnicianModal(true, UserModalState.NEW));
  };

  handleSignMsa = () => {
    this.props.dispatch(showSignMsaModal(this.contractorId));
  };

  handleMsaSigningModalClose = () => {
    this.props.dispatch(hideMsaSigningModal());
  };

  onSelectTab = (id) => {
    const { dispatch } = this.props;
    if (id === ContactorTeamTabs.Users.value) {
      dispatch(loadUsersRequest(id));
    } else {
      dispatch(loadTechnicianRequest(1, id));
    }
  };

  render() {
    let firstRowDetailsInfoItems = [];
    let secondRowDetailsInfoItems = [];
    const { activeTab } = this.props;

    if (this.props.contractor) {
      if (this.props.contractor.location) {
        firstRowDetailsInfoItems.push(
          <DetailsInfoItem
            lines={[
              this.props.contractor.location.street_address_1,
              this.props.contractor.location.city +
                ', ' +
                this.props.contractor.location.state +
                ' ' +
                this.props.contractor.location.zip,
            ]}
            title="ADDRESS"
          />
        );
      }
      firstRowDetailsInfoItems.push(
        <DetailsInfoItem
          lines={[
            <span className="contractor-name">
              {`${this.props.contractor.contact.first_name} ${this.props.contractor.contact.last_name}`}
            </span>,
            <a
              className="contractor-email"
              href={`mailto:${this.props.contractor.contact.email}`}
            >
              {this.props.contractor.contact.email}
            </a>,
            formatPhoneNumber(this.props.contractor.contact.phone_number),
          ]}
          title="PRIMARY CONTACT"
        />
      );
      firstRowDetailsInfoItems.push(
        <DetailsInfoItem
          lines={[this.props.contractor.license_number]}
          title="LICENSE NUMBER"
        />
      );
      secondRowDetailsInfoItems.push(
        <DetailsInfoItem
          lines={this.props.contractor.service_areas.map((element) => {
            return element.name;
          })}
          title="AREAS OF SERVICE"
        />
      );
      secondRowDetailsInfoItems.push(
        <DetailsInfoItem
          lines={this.props.contractor.unions.map((element) => {
            return (
              <span>
                {element.label}
                {element.detail !== null && (
                  <span className="union-detail">({element.detail})</span>
                )}
              </span>
            );
          })}
          title="UNIONS"
        />
      );
      secondRowDetailsInfoItems.push(
        <DetailsInfoItem
          lines={this.props.contractor.trades.map((element) => {
            return element.label;
          })}
          title="SPECIALITIES"
          truncate={true}
        />
      );
    }

    return (
      this.props.contractor !== null && (
        <div className="team">
          <RouteTitle
            titles={['COMPANY', this.props.contractor.name.toUpperCase()]}
          />

          <DetailsHeader
            leftHeader={{
              title: 'COMPANY',
              value: this.props.contractor.name,
            }}
            rightHeaders={[
              [
                {
                  title: 'STATUS',
                  value: (
                    <ContractorStatus status={this.props.contractor.status} />
                  ),
                },
                {
                  title: 'IN PROGRESS',
                  value: this.props.contractor.wo_in_progress_count,
                },
                {
                  title: 'COMPLETED',
                  value: this.props.contractor.wo_complete_count,
                },
              ],
            ]}
          />

          <div className="details-info-container">
            <DetailsInfo
              itemsContainerSize={10}
              itemsLines={[firstRowDetailsInfoItems, secondRowDetailsInfoItems]}
              rightContainerSize={2}
              rightContainer={
                <div className="contractors-documents-container">
                  <ContractorDocumentsViewer
                    contractor={this.props.contractor}
                  />
                </div>
              }
            />

            <div className="edit-button-container">
              {this.props.contractor.confirmed &&
                !this.props.contractor.msa_document && (
                  <input
                    type="button"
                    className="btn button button-orange"
                    value="Sign MSA"
                    onClick={this.handleSignMsa}
                  />
                )}
              <input
                type="button"
                className="btn button button-gray"
                value="Edit"
                onClick={this.handleEdit}
              />
            </div>
          </div>

          <div className="content-container">
            <div className="invite-container-space-between">
              <NavigationBar
                items={[
                  {
                    id: ContactorTeamTabs.Users.value,
                    title: ContactorTeamTabs.Users.label,
                  },
                  {
                    id: ContactorTeamTabs.Technicians.value,
                    title: ContactorTeamTabs.Technicians.label,
                  },
                ]}
                onSelected={this.onSelectTab}
              />
              <div>
                {activeTab === ContactorTeamTabs.Technicians.value && (
                  <input
                    type="button"
                    className="btn button button-orange"
                    value="Add technician"
                    onClick={this.handleInviteTechnician}
                  />
                )}
                {activeTab === ContactorTeamTabs.Users.value && (
                  <input
                    type="button"
                    className="btn button button-orange"
                    value="Invite"
                    onClick={this.handleInviteUser}
                  />
                )}
              </div>
            </div>

            {activeTab === ContactorTeamTabs.Users.value ? (
              <UsersTable />
            ) : (
              <TechniciansTable />
            )}
          </div>

          <ContractorTeamUserModalContainer />
          <ContractorTeamTechnicianModalContainer />

          <SigningModal
            show={this.props.showMsaSigningModal}
            url={this.props.msaSigningUrl}
            title="Sign MSA"
            handleClose={this.handleMsaSigningModalClose}
          />
        </div>
      )
    );
  }
}

export default connect((state) => {
  return {
    contractor: getCurrentContractor(state),
    currentUser: getCurrentUser(state),
    users: getUsers(state),
    msaSigningUrl: getMsaSigningUrl(state),
    showMsaSigningModal: getShowMsaSigningModal(state),
    activeTab: getActiveTab(state),
  };
})(ContractorTeam);



// WEBPACK FOOTER //
// ./src/components/admin/team/ContractorTeam.js